export enum DataTablePageSizeEnum {
	_10 = 10,
	_12 = 12,
	_15 = 15,
	_20 = 20,
	_30 = 30,
	_40 = 40,
	_50 = 50,
	_100 = 100,
	all = -1,
}
